export enum ReviewSection {
  PersonalDetails = 'PersonalDetails',
  Address = 'Address',
  TaxDetails = 'TaxDetails',
  Employment = 'Employment',
  IdentificationDriversLicence = 'IdentificationDriversLicence',
  IdentificationPassport = 'IdentificationPassport',
  IdentificationMedicare = 'IdentificationMedicare'
}
